var Wdot;
(function (Wdot) {
    var ModalWindow = (function () {
        function ModalWindow() {
        }
        ModalWindow.loadAjaxPost = function (width, height, url, d, postDialogFunction, title) {
            var ajax = new Wdot.Ajax();
            ajax.Post(url, d, function (data) {
                Wdot.ModalWindow.loadHtml(width, height, data, postDialogFunction, title);
            }, null, Wdot.ModalWindow.ajaxContentType);
        };
        ModalWindow.loadAjaxGet = function (width, height, url, postDialogFunction) {
            var ajax = new Wdot.Ajax();
            ajax.Get(url, null, function (data) {
                Wdot.ModalWindow.loadHtml(width, height, data, postDialogFunction, "");
            });
        };
        ModalWindow.loadHtml = function (width, height, html, postDialogFunction, title) {
            if ($("#dialog").length == 0) {
                Wdot.ModalWindow.dialog = $('<div id="dialog"></div>').appendTo('body');
            }
            Wdot.ModalWindow.dialog.dialog({
                dialogClass: "modal-classic",
                draggable: false,
                width: width,
                height: height,
                resizable: false,
                title: title || '',
                position: { my: "center", at: "center", of: window },
                modal: true
            }).html(html);
            //dialog.dialog('option', 'position', 'center');
            if (postDialogFunction != undefined)
                postDialogFunction();
        };
        return ModalWindow;
    }());
    ModalWindow.dialog = $("#dialog");
    ModalWindow.close = function () {
        Wdot.ModalWindow.dialog.dialog('close');
    };
    Wdot.ModalWindow = ModalWindow;
})(Wdot || (Wdot = {}));
//# sourceMappingURL=ModalWindow.js.map